import moment from 'moment';

/**
 * Valida si los datos de una empresa están actualizados según las reglas de negocio establecidas.
 *
 * @param {Object} empresa - Objeto empresa que contiene los campos muestra_empleados y ultima_fecha_actualizacion
 * @param {boolean} empresa.muestra_empleados - Flag que indica si la empresa tiene permiso para mostrar empleados sin restricción de fecha
 * @param {string} empresa.ultima_fecha_actualizacion - Fecha ISO de la última actualización de datos de la empresa
 *
 * @returns {boolean}
 * - `true` si los datos de la empresa están actualizados
 * - `false` si los datos de la empresa están desactualizados
 */
export const empresaEstaActualizada = empresa => {
  if (empresa.muestra_empleados) {
    return true;
  }
  if (!empresa.ultima_fecha_actualizacion) {
    return false;
  }

  const fechaActual = moment.utc();
  const diaActual = fechaActual.date();
  const fechaActualizacionEmpresa = moment.utc(
    empresa.ultima_fecha_actualizacion
  );

  if (fechaActualizacionEmpresa.isSame(fechaActual, 'month')) {
    return true;
  }
  if (diaActual <= 15) {
    const mesAnterior = fechaActual.clone().subtract(1, 'month');
    if (fechaActualizacionEmpresa.isSame(mesAnterior, 'month')) {
      return true;
    }
  }

  return false;
};
